import { render } from "./OrderNotes.vue?vue&type=template&id=e1d1aa6a&scoped=true"
import script from "./OrderNotes.vue?vue&type=script&lang=js"
export * from "./OrderNotes.vue?vue&type=script&lang=js"

import "./OrderNotes.vue?vue&type=style&index=0&id=e1d1aa6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d1aa6a"]])

export default __exports__